import type {
  CreateLicenseRequest,
  License,
  LicenseReturn,
  UpdateLicenseRequest
} from "../types";
import { baseApi } from "./base";

export const licenseApi = baseApi.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    /** Get paginated list of licenses with optional filters */
    listLicense: query<LicenseReturn, void>({
      query: () => ({
        url: "license/all",
      }),
      providesTags: ["License"],
    }),

    /** Create a new license */
    createLicense: mutation<License, CreateLicenseRequest>({
      query: (license) => ({
        url: "license/generate",
        method: "POST",
        body: license,
      }),
      invalidatesTags: ["License"],
    }),

    /** Update existing license */
    updateLicense: mutation<
      License,
      { id: string; data: UpdateLicenseRequest }
    >({
      query: ({ id, data }) => ({
        url: `license/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["License"],
    }),

    /** Activate license */
    activateLicense: mutation<License, string>({
      query: (id) => ({
        url: `license/${id}/activate`,
        method: "POST",
      }),
      invalidatesTags: ["License"],
    }),

    /** Suspend license */
    suspendLicense: mutation<License, string>({
      query: (id) => ({
        url: `license/${id}/suspend`,
        method: "POST",
      }),
      invalidatesTags: ["License"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListLicenseQuery,
  useCreateLicenseMutation,
  useUpdateLicenseMutation,
  useActivateLicenseMutation,
  useSuspendLicenseMutation,
} = licenseApi;
